module.exports = __webpack_public_path__ + "static/media/Nathan_Gold.73c3de5a.png";